<form [formGroup]="cloneWebsiteForm" (ngSubmit)="submit()">
  <!-- submit form with Enter -->
  <button [disabled]="loading" type="submit" style="display:none">hidden submit</button>

  <div class="db-website-install__section">
    <h4 class="mb20">{{'text_chooseWebsiteToClone' | dbText}}</h4>

    <db-create-website-install-websites-list
      [formSubmitted]="formSubmitted"
      [websites]="liveWebsites"
      [selectedWebsite]="selectedWebsite"
      (websiteSelected)="selectWebsite($event)"></db-create-website-install-websites-list>

  </div>

  <hr class="db-website-install__separator mt30 mb30">

  <div class="db-website-install__section">
    <h4 class="mb20">{{ 'text_selectSubdomainDataCenter' | dbText}}</h4>

    <div class="ds-input-wrap static mb28">
      <span class="ds-input-label">Subdomain</span>
      <div class="db-website-install__subdomain">
        <input type="text" class="ds-input mr20" maxlength="56"
               [class.error]="formSubmitted && cloneWebsiteForm?.get('subdomain')?.errors"
               placeholder="*subdomain" formControlName="subdomain">
          <span class="db-domain-link"
                [dsTooltip]="'.'+configHostname"
                [dsTooltipColor]="'black'"
                [hostClass]="'cover-all'"
                [dsTooltipAlign]="'left'"
                [dsTooltipPosition]="'top'"
                [dsTooltipSize]="'small'"
                [dsTooltipVisible]="shouldShowHostnameTooltip">
          .{{configHostname}}</span>
      </div>
      <span *ngIf="formSubmitted && cloneWebsiteForm?.get('subdomain')?.errors" class="ds-input-error-msg"
            [innerHTML]="cloneWebsiteForm?.get('subdomain')?.errors['required'] ?
            'This field is required.':
            cloneWebsiteForm?.get('subdomain')?.errors?.pattern ? ('text_fillFieldAllowedLetters' | dbText) :
            cloneWebsiteForm?.get('subdomain')?.errors?.taken ? cloneWebsiteForm?.get('subdomain')?.errors?.taken
            : ''"></span>
      <span class="ds-input-desc">{{ 'text_subDomainDescription' | dbText}}</span>

    </div>

    <div class="ds-input-wrap static">
      <ds-dropdown [dsDropdownOptions]="regions" formControlName="region"
                   [dsDropdownDisabled]="userSubscription?.type === UserSubscriptionCategory.DedicatedVM"
                   [dsDropdownLabel]="('text_regionDescription' | dbText)"></ds-dropdown>
    </div>

  </div>

</form>
